import React, {Component} from "react"

import Box from "@material-ui/core/Box"
import Fab from "@material-ui/core/Fab"
import {IntroSection, TabSegments, TitleSection} from "~/components/"
import history from "~/history.js"
import {AreaList} from "./list/AreaList"
import {LocationList} from "./list/LocationList"

import Grid from "@material-ui/core/Grid"
import AddIcon from "@material-ui/icons/Add"

import {withTranslation} from "react-i18next"

const introImage = require("~/images/WarehouseView Intro.svg")

class WarehouseView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tab: "Lagerplätze"
    }
  }

  returnFilteredAreas(query) {
    query = query.toLowerCase()
    let new_areas = []
    this.state.areas.forEach(function(area, index) {
      if (area.name.toLowerCase().includes(query)) {
        new_areas.push(area)
      }
    })
    return new_areas
  }

  render() {
    return (
      <div>
        <TitleSection>
          <Box display="flex" flex={1}>
            <h3>{this.props.t("warehouses.title")}</h3>
            <Box maxWidth={600}>
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
              >
                <Grid item>
                  {this.state.tab === "Zonen" ? (
                    <Fab
                      variant="extended"
                      color="primary"
                      aria-label="add-zone"
                      size="medium"
                      onClick={() => history.push("/areas/new")}
                    >
                      <AddIcon />
                      {this.props.t("warehouses.newZone")}
                    </Fab>
                  ) : (
                    <Fab
                      variant="extended"
                      color="primary"
                      aria-label="add-zone"
                      size="medium"
                      onClick={() => history.push("/locations/new")}
                    >
                      <AddIcon />
                      {this.props.t("warehouses.newLocation")}
                    </Fab>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </TitleSection>
        <IntroSection image={introImage}>
          <p>
            Lagerartikel werden auf <strong>Lagerplätzen</strong> eingelagert,
            welche in übergeordneten <strong>Zonen</strong> organisiert sind.
          </p>
        </IntroSection>

        <TabSegments onSetActiveTab={tab => this.setState({tab})}>
          <TabSegments.Segment label={this.props.t("warehouses.locations")}>
            <LocationList />
          </TabSegments.Segment>
          <TabSegments.Segment label={this.props.t("warehouses.zones")}>
            <AreaList />
          </TabSegments.Segment>
        </TabSegments>
      </div>
    )
  }
}

export default withTranslation()(WarehouseView)



// WEBPACK FOOTER //
// ./src/views/WarehouseView.js